import { render, staticRenderFns } from "./PhonePe.vue?vue&type=template&id=0ac2749e&scoped=true&"
import script from "./PhonePe.vue?vue&type=script&lang=js&"
export * from "./PhonePe.vue?vue&type=script&lang=js&"
import style0 from "./PhonePe.vue?vue&type=style&index=0&id=0ac2749e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2749e",
  null
  
)

export default component.exports